













































import { Component, Vue } from 'vue-property-decorator'
import { LoginResult } from '@/api/auth'
import Header from '@/components/header'

@Component({
  components: {
    Header
  }
})
export default class MainLayout extends Vue {
  navList: any[] = [
    { name: 'courseIndex', title: '云端课程', icon: 'cloud' },
    { name: 'courseMy', title: '我的课程', icon: 'read' },
    { name: 'courseEdit', title: '创建课程', icon: 'appstore' }
    // { name: 'classIndex', title: '进入课堂' }
  ]
  list: any[] = []

  get i18n() {
    const value = this.$t('login')
    return value as any
  }
  get nav() {
    const nav = this.$route.meta.nav || this.$route.name
    return nav
  }

  get fullMain() {
    return !!this.$route.meta.fullMain
  }

  created() {
    const lang2 = this.i18n.vAdmin
    const user = this.$store.state.user
    const lang3 = this.i18n.vStudy
    const lang4 = this.i18n.resource

    if (user && user.role == 0) {
      this.list = [
        { name: 'account', title: lang2.accountManage },
        // { name: 'content', title: lang2.contentManage },
        { name: 'install', title: lang2.install },
        { name: 'binding', title: this.i18n.vStudentList.stuMenage },
        // { name: 'study', title: lang3.studyData },
        { name: 'resourceList', title: lang4.resource },
        { name: 'client', title: this.i18n.vClients.clientsSet },
        // { name: 'studentMenage', title: '学生管理' }
      ]
    } else {
      this.list = [
        { name: 'binding', title: this.i18n.vStudentList.stuMenage },
        // { name: 'study', title: lang3.studyData },
        { name: 'resourceList', title: lang4.resource },
        { name: 'client', title: this.i18n.vClients.clientsSet },
        // { name: 'studentMenage', title: '学生管理' }
      ]
    }
  }
  linkto(name: any) {
    localStorage.setItem('page-' + name, '1')
    this.$router.push({
      name
    })
  }
  refresh() {
    // 　　　　　　this.$router.go(0);
  }
}
